import PenIcon from "../../../../assets/icons/Pen";
import Modal from "../../../../components/general/Modal";
import { Container, Content, Header, Button, Description } from "./styles";
import Input from "../../../../components/general/Input";
import Close from "../../../../assets/icons/Close";

/**
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {(event: React.FormEvent<HTMLFormElement>) => void} props.onSubmit
 * @param {Object} props.form
 * @param {string} [props.title]
 * @param {boolean} [props.disabled]
 */
export const RdmModal = ({
  title,
  isOpen,
  onClose,
  onSubmit,
  form,
  disabled,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container>
        <Content>
          <Header>
            <div style={{ display: "flex", alignItems: "center" }}>
              <PenIcon width={20} height={20} />
              <span>{title ?? "Novo Rdm"}</span>
            </div>
            <Close
              style={{
                cursor: "pointer",
                height: "0.95625rem",
                width: "1.3125rem",
              }}
              onClick={onClose}
            />
          </Header>
          <form onSubmit={onSubmit}>
            <Input
              value={form.title.value}
              setValue={form.title.onChange}
              label="Nome do Rdm"
              placeholder="Ex. Relatório de Projeto de Obras"
              type="text"
              maxLength={100}
              onKeyDown={(e) => (e.key === "Enter" ? onClose() : null)}
            />
            <Description>
              <span>Descrição</span>
              <textarea
                value={form.description.value}
                onChange={form.description.onChange}
                name="TaskDescriptionArea"
                type="text"
                maxLength={5000}
              />
            </Description>
            <Button
              disabled={
                !form.title.value || !form.description.value || disabled
              }
              type="submit"
            >
              Confirmar
            </Button>
          </form>
        </Content>
      </Container>
    </Modal>
  );
};
